import UNIT_TYPES from "../../configs/units";
import {UNIT_D4_MAX_SHOOTING_RANGE} from "../../constants/units";
import {ELVES_SHOOTING_RANGE} from "../../configs/factions/elves";
import {FACTIONS} from "../../constants/factions";

/**
 * Дальность стрельбы отряда для показа в статах (футер найма, осмотр клетки)
 * или null, если отряд не стреляет. Правила те же, что у расчета целей:
 * катапульта (D4) любой фракции, в том числе эльфов, бьет на свою дальность
 * (calculateAvailableShootingCells), остальные отряды эльфов — на эльфийскую
 * (calculateAvailableShootingCellsForElves, см. checkIfUnitMeleeElf).
 * factionId — фракция самого отряда (у соблазненного Суккубом — исходная), у
 * еще не нанятого — фракция игрока
 */
export const getUnitShootingRange = (unitTypeId, factionId) => {
  if (unitTypeId === UNIT_TYPES.D4.id) {
    return UNIT_D4_MAX_SHOOTING_RANGE;
  }
  if (factionId === FACTIONS.ELVES) {
    return ELVES_SHOOTING_RANGE;
  }
  return null;
};
